var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ loading: !_vm.is_inited },attrs:{"id":"app"}},[(_vm.is_inited)?_c('RouterView',{key:((_vm.$route.fullPath) + "|" + _vm.locale)}):_c('vue-loaders-line-spin-fade-loader',{attrs:{"color":"#fff","size":"100px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }